import { render } from "./ValueBox.vue?vue&type=template&id=17b34e58&scoped=true&ts=true"
import script from "./ValueBox.vue?vue&type=script&lang=ts"
export * from "./ValueBox.vue?vue&type=script&lang=ts"

import "./ValueBox.vue?vue&type=style&index=0&id=17b34e58&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/hems-frontend-vue_au_v1.33.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17b34e58"]])

export default __exports__